import paths from "@icarius-router/paths";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("locationGroup"),
            field: "group",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("groupAppearanceSequence"),
            field: "sequence",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("activeFemale"),
            field: "activeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("kpiType"),
            field: "kpiTypeString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("visualizationRol"),
            field: "rolString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("queryCode"),
            field: "code",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("name"),
            field: "name",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("publicationDateFrom"),
            field: "tempStartDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("publicationEndDate"),
            field: "tempEndDate",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            cellClass: "dateFormat",
        }
    },
    {
        pages: [paths.kpiDefinition],
        config: {
            headerName: getLocalizedString("digitalFolderTextodescriptivo"),
            field: "description",
            filter: "agTextColumnFilter",
        }
    },
]